import { render, staticRenderFns } from "./tab-row-colors.vue?vue&type=template&id=69e77e82&"
import script from "./tab-row-colors.vue?vue&type=script&lang=js&"
export * from "./tab-row-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports